import { render, staticRenderFns } from "./monitoring-appointments.vue?vue&type=template&id=dc0fe88e&scoped=true"
import script from "./monitoring-appointments.vue?vue&type=script&lang=js"
export * from "./monitoring-appointments.vue?vue&type=script&lang=js"
import style0 from "./monitoring-appointments.vue?vue&type=style&index=0&id=dc0fe88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0fe88e",
  null
  
)

export default component.exports